import { render, staticRenderFns } from "./CommissionStatusColumn.vue?vue&type=template&id=42087b14&scoped=true&"
import script from "./CommissionStatusColumn.vue?vue&type=script&lang=js&"
export * from "./CommissionStatusColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42087b14",
  null
  
)

export default component.exports